import React, {useState, useEffect} from "react";
/* import Modal from "./Modal"; */
import { motion, AnimatePresence } from "framer-motion";
import modifyState from "functions/modifyState";
/* import clg from "functions/log"; */

/*
    const [feedback,setFeedback] = useState({
        open : false,
        success : false,
        title : null,
        text : null,
    })

    //Sikeres
    modifyState( feedback, setFeedback, {"open" : true, "success" : true} );

    //Sikertelen
    modifyState( feedback, setFeedback, {"open" : true, "success" : false} );

    <FeedbackModal open={feedback.open} success={feedback.success} title={feedback.title} text={feedback.text} defaultState={ feedback } setDefaultState={ setFeedback }/> 
*/

const FeedbackModal = ({success, title = null, text = null, open = false, defaultState = null, setDefaultState = null}) => {

    const [openState, setOpenState] = useState(null);

    useEffect(() => {
        setOpenState(open);
    },[open])

    let _text = ( success ? "A művelet végrehajtása sikeresen megtörtént" : "A művelet végrehajtása során hiba történt. Próbálja újra!" );
    _text = ( text ? text : _text );

    const closeCallback = () => {
        if( setDefaultState && defaultState ) {
            modifyState( defaultState, setDefaultState, {
                open : false,
                success : false,
                title : null,
                text : null,
            })
        }
    }

    {/* <Modal state={openState} setState={setOpenState} title={ title && title } closeCallback={ () => closeCallback() } bodyClassName="feedback-modal">
        <div className="row">
            <div className={`col-12 icon-container ${ success ? "success" : "error" }`}>
                { success ? <i className="fas fa-check"></i> : <i className="fas fa-times"></i> }
            </div>
            <div className="col-12 text-container">
            {_text}
            </div>
        </div>
    </Modal> */}

    useEffect(() => {
        if( openState ) {
            const t = setTimeout(() => {
                setOpenState(false);
                closeCallback();
            }, 4000);

            return () => clearTimeout(t);
        }
    },[openState]);

    const variants = {
        open : {
            opacity: 1,
            x:0,
        },
        close : {
            opacity: 0,
            x:"100%",
        }
    }

    return(
        <AnimatePresence>
            { openState && (
                <div className="feedback-container">
                
                    <motion.div className="row feedback"
                    variants={variants}
                    initial="close"
                    exit="close"
                    animate={ openState ? "open" : "close" }
                    >
                        <div className={`icon-container ${ success ? "success" : "error" }`}>
                            { success ? <i className="fas fa-check"></i> : <i className="fas fa-times"></i> }
                        </div>
                        <div className="title">
                            {title && title}
                        </div>
                        <div className="text">
                            {_text && _text}
                        </div>
                    </motion.div>
                </div>
            )}
        </AnimatePresence>
    )
}



export default FeedbackModal;